import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/periscope': {
    width: 448,
    height: 512,
    paths: [
      {
        d: 'M370 63.6c38.4 40.7 59.5 94.3 59.5 150.8 0 74.3-57.4 159.5-82 192.6-8 10.8-79.3 105-120.9 105-34 0-88.8-56.5-125.4-104.9-24.9-32.9-82.7-117.6-82.7-192.7 0-118.2 93.4-214.4 208.1-214.4 53.9 0 104.8 22.6 143.4 63.6zM226.6 493.9c37.3 0 184.8-167.3 184.7-279.4 0-107.3-83.9-196.3-184.7-196.3-106.1 0-190 88.9-190 196.3 0 112.1 147.5 279.4 190 279.4zM338 206.8c0 59.1-51.1 109.7-110.8 109.7-100.6 0-150.7-108.2-92.9-181.8v0.4c0 24.5 20.1 44.4 44.8 44.4 24.7 0 44.8-19.9 44.8-44.4 0-18.2-11.1-33.8-26.9-40.7 76.6-19.2 141 39.3 141 112.4z'
      }
    ]
  }
})
